"use client";
import { sidebarSlice } from "@/components/common/sidebar/redux/reducer";
import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({
        reducer: {
          [sidebarSlice.name]: sidebarSlice.reducer,
        //   [socialMediaSlice.name]: socialMediaSlice.reducer,
        },
        devTools: true,
});
